import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from 'react-toast-notifications';
import { AuthProvider } from './context/authContext';
import { ContextProvider } from './context/contactContext';
import LandingPage from "./pages/landingpage/landingpage"
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const LazyApp = React.lazy(()=>import("./App"))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider  placement="bottom-center" >
      <AuthProvider>
        <ContextProvider>
          <React.Suspense fallback={<LandingPage />}>
            <LazyApp />
          </React.Suspense>
        </ContextProvider>
      </AuthProvider>
    </ToastProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
